<script>
  //let COLUMN_KEY_ID = 1
  import mixTable from '@/utils/mixTable'
  import RenderColumnVue from './components/renderColumn.vue'
  export default {
    name: 'VabValidateTable',
    components: { RenderColumnVue },
    mixins: [mixTable],
    provide() {
      return {
        tableRoot: this,
      }
    },
    props: {
      prop: {
        type: String,
        default: null,
      },
      rowIndex: {
        type: Number,
        default: null,
      },
      parentRow: {
        type: Object,
        default: null,
      },
      customClass: {
        type: Array,
        default: () => ['vue-jsx-table-wrapper'],
      },
    },
    render() {
      const that = this
      // if (this.tableData && this.tableData.length > 0) {
      //   this.dataSource = this.tableData
      // }
      const navbarSlot = this.$scopedSlots.navbar
      const data = { tableData: that.tableData }
      let navtool = null
      let rightRender = null
      if (navbarSlot && navbarSlot(data)) {
        rightRender = (
          <vab-box-area-right-panel>
            {navbarSlot ? navbarSlot(data) : ''}
          </vab-box-area-right-panel>
        )
      }
      if (that.navButtons.length > 0 || navbarSlot) {
        navtool = (
          <vab-box-area>
            <vab-box-area-left-panel>
              {that.navButtons.map((item) => {
                return (
                  <el-button
                    icon={item.icon}
                    type={item.type}
                    on={{
                      click: () => {
                        if (item.click) {
                          item.click.call(that, that.tableData)
                        }
                      },
                    }}
                  >
                    {item.name}
                  </el-button>
                )
              })}
            </vab-box-area-left-panel>
            {rightRender}
          </vab-box-area>
        )
      }
      return (
        <div class={`vue-jsx-table-wrapper ${that.customClass}`}>
          {navtool}
          <el-table
            highlight-current-row
            data={this.dataSource}
            show-summary={this.showSummary}
            summary-method={this.getSummaries}
            ref="table"
            {...{
              props: this.$attrs,
              on: this.$listeners,
            }}
          >
            {that.columns.map((item) => {
              let columnConfig = Object.assign(
                {},
                item,
                that.defaultColumnConfig
              )
              return <RenderColumnVue column={columnConfig} />
            })}
          </el-table>
        </div>
      )
    },
  }
</script>

<style scoped lang="scss">
  .vue-jsx-table-wrapper {
    position: relative;

    .el-table ::v-deep {
      .el-form-item--mini.el-form-item {
        margin-bottom: 0;
      }

      .is-error {
        animation: errvalid 0.5s;
        animation-fill-mode: forwards;
        .el-form-item__error {
          font-size: 10px !important;
        }
      }

      .is-success {
        animation: sucvalid 0.5s;
        animation-fill-mode: forwards;
      }

      @keyframes errvalid {
        from {
          margin-bottom: 0;
        }
        to {
          margin-bottom: 28px;
        }
      }
      @keyframes sucvalid {
        from {
          margin-bottom: 28px;
        }
        to {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
